import React from 'react';

import { ReactComponent as Cadeado } from '../../../assets/rebranding/objetos/cadeado.svg';
import { Body, CardBase, DirectionButton, Title } from '@icarros/ids-react';
import { CardBaseWrapper } from './style';

export function PhoneScamCard({ handleClick }: Readonly<{ handleClick: () => void }>): JSX.Element {
  return (
    <CardBaseWrapper>
      <CardBase variant="default" selected={false} hasHover={false}>
        <Cadeado />
        <Title size="overline">O icarros não pede seus dados nem códigos de verificação</Title>
        <Body variant="variant">
          Por isso, se entrarem em contato em nome do icarros é golpe! Nunca compartilhe suas
          senhas, protocolos de atendimento ou códigos (SMS, e-mail ou WhatsApp).
        </Body>
        <DirectionButton
          onClick={handleClick}
          variant="secondary"
          text="Conferir mais dicas de segurança"
        />
      </CardBase>
    </CardBaseWrapper>
  );
}
